import * as localforage from "localforage";
import { createResilientStore } from "./resilient-localforage";

const localforageFormCacheData = createResilientStore(localforage.createInstance({
	driver      : localforage.INDEXEDDB,
	name        : 'Immo',
	version     : 1.0,
	size        : 4980736,
	storeName   : 'omnicasa-form-data',
	description : 'Omnicasa Web application Form edit caching data'
}), 'omnicasa-form-data');

export class LocalforageWrapper{
	static getItem<T>(key: string): Promise<T> {
		return localforageFormCacheData.getItem<T>(key);
	}
	
	static setItem<T>(key: string, value: T): Promise<T> {
		return localforageFormCacheData.setItem<T>(key, value);
	}
	
	static removeItem(key: string): Promise<void> {
		return localforageFormCacheData.removeItem(key);
	}
	
	static clear(): Promise<void> {
		return localforageFormCacheData.clear();
	}
}
